export default __webpack_public_path__ + "static/media/header_bg.ada8d1a2.png";